import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "vastra_access_token";

export function getStoredToken() {
    try { return localStorage.getItem(TOKEN_KEY) || null; } catch { return null; }
}
export function setStoredToken(token) {
    try {
        if (token) localStorage.setItem(TOKEN_KEY, token);
        else localStorage.removeItem(TOKEN_KEY);
    } catch {}
}

const api = axios.create({
    baseURL: API,
    withCredentials: true,
});

// Attach Bearer token (fallback when Safari blocks third-party cookies on custom domains)
api.interceptors.request.use((config) => {
    const t = getStoredToken();
    if (t) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${t}`;
    }
    return config;
});

export default api;

export function formatApiErrorDetail(detail) {
    if (detail == null) return "Something went wrong. Please try again.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}

export function getSessionId() {
    let sid = localStorage.getItem("ayraa_sid");
    if (!sid) {
        sid = "sid_" + Math.random().toString(36).slice(2) + Date.now().toString(36);
        localStorage.setItem("ayraa_sid", sid);
    }
    return sid;
}

export const FAVORITES_KEY = "ayraa_favorites";

export function getFavorites() {
    try { return JSON.parse(localStorage.getItem(FAVORITES_KEY) || "[]"); } catch { return []; }
}

export function toggleFavorite(saree) {
    const favs = getFavorites();
    const idx = favs.findIndex((f) => f.id === saree.id);
    if (idx >= 0) favs.splice(idx, 1);
    else favs.unshift({ id: saree.id, title: saree.title, price: saree.price, image: saree.images?.[0], shop_slug: saree.shop_slug });
    localStorage.setItem(FAVORITES_KEY, JSON.stringify(favs.slice(0, 100)));
    return favs;
}

export function isFavorite(id) {
    return getFavorites().some((f) => f.id === id);
}
